(function () {

  function getLoopBlock() {
    // Find by hardcoded ID first (fast path)
    const byId = document.getElementById('shopify-block-AT0IyNUdHdWgyY3lBN__loop_subscriptions_loop_widget_L4nYkB');
    if (byId) return byId;

    // Fallback: find by Loop's own data attribute (works regardless of block ID)
    const byAttr = document.querySelector('[data-loop-widget-purchase-option]');
    if (byAttr) return byAttr.closest('[id^="shopify-block"]') || byAttr.closest('.loop-widget, [class*="loop"]') || byAttr.parentElement;

    return null;
  }

  function toggleLoop() {
    const block = getLoopBlock();
    if (!block) return;

    const checkedInput = document.querySelector('variant-picker input[type="radio"]:checked');
    if (!checkedInput) return;

    const show = checkedInput.value.toLowerCase().includes('big bear');

    if (show) {
      const subscribeOption = block.querySelector('[data-loop-widget-purchase-option][aria-label="Subscribe & Save"]');
      if (subscribeOption && subscribeOption.getAttribute('aria-checked') !== 'true') {
        subscribeOption.click();
      }
      block.style.display = '';
    } else {
      const oneTimeOption = block.querySelector('[data-loop-widget-purchase-option][aria-label="One-time purchase"]');
      if (oneTimeOption && oneTimeOption.getAttribute('aria-checked') !== 'true') {
        oneTimeOption.click();
      }
      block.style.display = 'none';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    toggleLoop();
    document.addEventListener('variant:update', toggleLoop);
    document.querySelector('variant-picker')?.addEventListener('change', toggleLoop);
  });
})();